import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=ee6847a8&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee6847a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ee6847a8')) {
      api.createRecord('ee6847a8', component.options)
    } else {
      api.reload('ee6847a8', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=ee6847a8&scoped=true&", function () {
      api.rerender('ee6847a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2MoLBS243NdfA/JS/comp/Accordion.vue"
export default component.exports